var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * Tells whether the current page is the first history entry of this app load.
 *
 * Pages opened straight from outside (a one-time sign-in link 302s to #/Settings, an email link,
 * a refresh) have nothing of ours behind them, so a header back button that calls goBack() would
 * leave the portal for the browser's previous page or start page.
 *
 * The entry is tagged in window.history.state: hash history pushes and replaces through
 * location.hash / location.replace, which leave state null, so only the entry we tag carries it.
 * Tags outlive the load: after a refresh on a deeper page both that page and the earlier entry
 * stay tagged, so returning to either goes home rather than back. That errs on staying in the app.
 */
var ENTRY_MARK = "__rspEntry__";
var isOnEntry = true;
var stopListening = null;
function markEntry() {
    var _a;
    try {
        window.history.replaceState(__assign(__assign({}, (window.history.state || {})), (_a = {}, _a[ENTRY_MARK] = true, _a)), "");
    }
    catch (e) {
        // no-op: without the mark back simply falls through to goBack()
    }
}
function isEntryMarked() {
    var state = window.history.state;
    return !!(state && state[ENTRY_MARK]);
}
/**
 * Call with the router's history, before any in-app navigation. Calling again (a remounted router,
 * HMR) moves tracking to the new history and keeps what we know about the current page.
 */
export var trackEntryHistory = function (history) {
    if (stopListening) {
        stopListening();
    }
    if (isOnEntry) {
        markEntry();
    }
    stopListening = history.listen(function (_location, action) {
        if (action === "PUSH") {
            isOnEntry = false;
        }
        else if (action === "REPLACE") {
            // A redirect on the entry page drops our state; keep the new URL tagged as the entry.
            if (isOnEntry) {
                markEntry();
            }
        }
        else {
            isOnEntry = isEntryMarked();
        }
    });
    return stopListening;
};
/** Back for in-app headers: goBack() when we have a page behind us, else home. */
export var goBackOrHome = function (history) {
    if (isOnEntry) {
        history.replace("/");
    }
    else {
        history.goBack();
    }
};
